export default "__VITE_ASSET__BJVUZ4Ae__"